import { getFISuperType } from './fiGroups';

export const sortFITypes = (superTypes) => {
    return superTypes.sort((a, b) => {
        return a.localeCompare(b);
    });
};

export const sortAccountsByName = (accounts) => {
    return accounts.sort((a, b) => {
        const nameA = a.fipName || a.fipId || '';
        const nameB = b.fipName || b.fipId || '';
        return nameA.localeCompare(nameB);
    });
};

export const groupAccountsBySuperType = (accounts) => {
    const grouped = {};
    
    accounts.forEach(account => {
        const fiType = account.fiType || account.FIType || 'OTHER';
        const superType = getFISuperType(fiType);
        
        if (!grouped[superType]) {
            grouped[superType] = [];
        }
        grouped[superType].push(account);
    });
    
    return grouped;
};
